import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import user from "../public/assets/img/user.png";
import { toast, ToastContainer } from "react-toastify";
import { getUser } from "../../utils/helper"
import Breadcrumb from "../Breadcrumb";
import MetaHelmet from "../MetaHelmet";

const Settings = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    id: "",
    fullName: "",
    email: "",
    profileImage: "",
    image: null,
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const fileInputRef = useRef(null);


  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/";
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchUserData();
  }, [navigate, API_BASE_URL]);

  const fetchUserData = async () => {
    if (!token) {
      navigate("/");
      return;
    }
    try {
      // const profileResponse = await axios.get(`${API_BASE_URL}profile-information`, {
      //   headers: { Authorization: `Bearer ${token}` },
      // });
      const profileResponse = await getUser()
      // setUserData(data)


      if (profileResponse.data.user) {
        const userId = profileResponse.data.user.id;

        const businessResponse = await axios.get(`${API_BASE_URL}get-user-by-id/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const userInfo = businessResponse.data.user || profileResponse.data.user;

        setUserData({
          id: userInfo.id,
          fullName: userInfo.name || "",
          email: userInfo.email || "",
          profileImage: userInfo.image_url || "",
          image: null,
        });
      }
    } catch (err) {
      console.error("Error fetching user data:", err);
      setError("Failed to fetch user data");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUserData((prevData) => ({
        ...prevData,
        image: file,
        profileImage: URL.createObjectURL(file),
      }));
    }
  };

  const handleSubmit = async () => {
    try {
      if (userData.id) {
        const formData = new FormData();
        formData.append("name", userData.fullName);
        formData.append("email", userData.email);
        if (userData.image) {
          formData.append("image", userData.image);
        }

        const response = await fetch(`${API_BASE_URL}update-profile-customer/${userData.id}`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });

        const responseData = await response.json();
        if (!response.ok) {
          throw new Error(responseData.message || "Failed to update profile");
        }

        toast.success("Profile updated successfully");
        if (userData.image) {
          const imageUrl = URL.createObjectURL(userData.image);
          setUserData((prevData) => ({
            ...prevData,
            profileImage: imageUrl,
          }));

        }
        navigate("/dashboard")
        window.location.reload();

      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  if (loading) {
    return (
      <div id="loader-wrapper">
        <span className="loader"></span>
      </div>
    );
  }

  const routes = [
    { name: "Home", path: "/dashboard" },
    { name: "Settings", path: "/setting" },

  ];

  return (
    <>
      <MetaHelmet title={`Local Shouts | Settings`} />

      <div className="container" id="business-index">
        <div className="settings-page">
          <div className="form-content">
            <ToastContainer />
            <Breadcrumb routes={routes}></Breadcrumb>
            <div className="form-details">
              <div className="d-flex-center w-100">
                <div className=" form-group form-label img-align my-3">
                  <label htmlFor="inputProfilePicture">Profile Image:</label>
                  <input
                    type="file"
                    className="form-control form-border"
                    id="inputProfilePicture"
                    name="img"
                    accept="image/*"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleImageUpload}
                  />
                  <div onClick={() => fileInputRef.current.click()} className="ps-0 form-selected-image">
                    {userData.profileImage ? (
                      <div className="user-img position-relative">
                        <img
                          src={userData.profileImage}
                          alt="Profile"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                            // border: "1px solid #e3e3e3",
                          }}
                        />
                        <div className="fa-icon-pen">
                          <i className="fa-solid fa-pen"></i>
                        </div>
                      </div>
                    ) : (
                      <div className="image-upload ps-0">
                        <div className="user-img position-relative">
                          <img src={user} alt="Default User" />
                          <div className="fa-icon-pen">
                            <i className="fa-solid fa-pen"></i>
                          </div>
                        </div>
                      </div>
                    )}

                  </div>
                </div>
                <div className="form-group form-label my-3">
                  <label>Full Name:</label>
                  <input
                    type="text"
                    className="form-control form-setting"
                    name="fullName"
                    value={userData.fullName || ""}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group form-label my-3">
                  <label>Email:</label>
                  <input
                    type="email"
                    className="form-control form-setting"
                    name="email"
                    value={userData.email || ""}
                    onChange={handleInputChange}
                    readOnly
                  />
                </div>

                {error && <div className="alert alert-danger">{error}</div>}

                <div className="form-group form-btns my-3">
                  <button className="btn ls-btn primary-btn" onClick={handleSubmit}>
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default Settings;
